import { GetOneNotificationInDto, GetOneNotificationOutDto } from '../../../types/notification.dto'

export const GET_ONE_NOTIFICATION = 'GET_ONE_NOTIFICATION'
export const GET_ONE_NOTIFICATION_SUCCESS = 'GET_ONE_NOTIFICATION_SUCCESS'
export const GET_ONE_NOTIFICATION_ERROR = 'GET_ONE_NOTIFICATION_ERROR'
export const RESET_GET_ONE_NOTIFICATION = 'RESET_GET_ONE_NOTIFICATION'

export interface GetOneNotification {
  type: typeof GET_ONE_NOTIFICATION
  payload: GetOneNotificationOutDto
}

export interface GetOneNotificationSuccess {
  type: typeof GET_ONE_NOTIFICATION_SUCCESS
  payload: GetOneNotificationInDto
}

export interface GetOneNotificationError {
  type: typeof GET_ONE_NOTIFICATION_ERROR
  payload: string | boolean
}

export interface ResetGetOneNotification {
  type: typeof RESET_GET_ONE_NOTIFICATION
  payload: null
}

export interface State {
  data: GetOneNotificationInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = GetOneNotification | GetOneNotificationSuccess | GetOneNotificationError | ResetGetOneNotification
